import React from 'react';
import { Switch } from 'antd';
import {
  FmFormField,
  type FmBinaryFieldDescriptor,
  type FmFormFieldMetaProps,
} from './FmForm';

export interface FmSwitchProps extends FmFormFieldMetaProps {
  descriptor?: FmBinaryFieldDescriptor;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  checkedLabel?: string;
  uncheckedLabel?: string;
  ariaLabel?: string;
}

const toDescriptor = (props: FmSwitchProps): FmBinaryFieldDescriptor => ({
  kind: 'binary',
  control: 'switch',
  name: props.name ?? '',
  label: String(props.label ?? ''),
  helper: props.helper ? String(props.helper) : undefined,
  error: props.error ? String(props.error) : undefined,
  required: props.required,
  basisNote: props.basisNote ? String(props.basisNote) : undefined,
  disabledReason: props.disabledReason ? String(props.disabledReason) : undefined,
  lockedReason: props.lockedReason ? String(props.lockedReason) : undefined,
  validation: props.validation,
  intent: props.intent,
  density: props.density,
  layoutPreset: props.layoutPreset,
  disabled: props.disabled,
  testId: props['data-testid'],
  checked: props.checked,
  defaultChecked: props.defaultChecked,
  onChange: props.onChange,
  checkedLabel: props.checkedLabel,
  uncheckedLabel: props.uncheckedLabel,
});

export const FmSwitch: React.FC<FmSwitchProps> = (props) => {
  if (props.descriptor) {
    return <FmFormField descriptor={props.descriptor} />;
  }

  if (props.name && props.label) {
    return <FmFormField descriptor={toDescriptor(props)} />;
  }

  return (
    <Switch
      checked={props.checked}
      defaultChecked={props.defaultChecked}
      onChange={props.onChange}
      disabled={props.disabled}
      checkedChildren={props.checkedLabel}
      unCheckedChildren={props.uncheckedLabel}
      aria-label={props.ariaLabel}
      data-testid={props['data-testid']}
      className="fm-switch"
    />
  );
};

export default FmSwitch;
